import { sbaAxios } from "../utils/sbaAxios";
import { assetListUrl } from "../../config/apiConfig";
import {
  FETCH_ASSETLIST_BEGIN,
  FETCH_ASSETLIST_SUCCESS,
  FETCH_ASSETLIST_FAILURE
  } from '../constants/assets';


export const getAssetLists=()=> {
  return (dispatch) => {
      dispatch(fetchAssetListsBegin());
      sbaAxios({
          url: `${assetListUrl}`,
          method: 'get',
      })
      .then((repos) => {
        const AssetList = repos;
        //Add logic to format the DataItem if needed using map
        dispatch(fetchAssetListSuccess(AssetList));
        return AssetList;
      })
      .catch((error) => {return dispatch(fetchAssetListFailure(error))});
  };
}

export const fetchAssetListsBegin = () => ({
  type: FETCH_ASSETLIST_BEGIN,
});

export const fetchAssetListSuccess = (assetDataItems) => ({
  type: FETCH_ASSETLIST_SUCCESS,
  payload: {assetDataItems},
});


export const fetchAssetListFailure = (errorMessage) => ({
  type: FETCH_ASSETLIST_FAILURE,
  payload: {errorMessage}
});

